// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__25oKt","emails":"CreateEditClinics_emails__1weUG","emailTagLabel":"CreateEditClinics_emailTagLabel__ZIZ3u"};